import React, { useState, useEffect } from 'react';
import SlideDown from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import DropDown from './CustomSelect/DropDown';
import IconClientExit from '../icon/IconClientExit';
import './index.scss';

const SelectUserTrench = ({
  label,
  id,
  name,
  placeholder,
  selectData,
  onChangeSelectData,
  selectedTransh,
  setSelectedTranshTransh,
  pointerEvent,
}) => {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleClick = (e) => {
    setOpen((prev) => !prev);
  };

  const handleSelect = (el, name) => {
    const newData = selectData.map((d) => {
      if (d.number === el)
        return {
          ...d,
          active: !d.active,
        };
      else return d;
    });
    setSelectedTranshTransh(newData.filter((el) => el.active));
    onChangeSelectData(newData);
    setOpen(false);
  };

  const handleUnSelect = (el, name) => {
    const newData = selectData.map((d) => {
      if (d.number === el)
        return {
          ...d,
          active: false,
        };
      else return d;
    });
    setSelectedTranshTransh(newData.filter((el) => el.active));
    onChangeSelectData(newData);
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest('#SelectDropdown-' + id)) {
        setOpen(false);
      }
    };

    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [id]);

  useEffect(() => {
    const handleWindowResize = () => {
      if (window.innerWidth < 500) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const handleUnselectAll = () => {
    const newData = selectData.map((d) => ({ ...d, active: false }));
    onChangeSelectData(newData);
  };

  return (
    <div
      className={`select_main ${pointerEvent ? "disabled_select" : ""}`}
      id={"SelectDropdown-" + id}
      name={name}
    >
      <span className="select_text"> {label} </span>
      <div className="select_container_main" onClick={(e) => handleClick(e)}>
        <div className={`select_container ${open ? "opened" : ""}`}>
          <div className="value">
            <span className="place">
              {selectData?.filter((el) => el.active)?.length === 0 && placeholder}
            </span>
            {selectData
              ?.filter((el) => el.active)
              .slice(0, isMobile ? 1 : 2)
              ?.map((el, i) => (
                <span key={i} className=" selected-tranch">
                  {el.number}
                  <IconClientExit
                    onClick={() => handleUnSelect(el.number, name)}
                  />
                </span>
              ))}
            {!isMobile && selectData.filter((el) => el.active).length >= 2 && (
              <div className="more-unselec-div">
                <div className="unselec-div">
                  {selectData.filter((el) => el.active).length} <span></span>
                </div>
                <div className="icon-select-clear" onClick={handleUnselectAll}>
                  <IconClientExit />
                </div>
              </div>
            )}
            {isMobile && selectData.filter((el) => el.active).length >= 1 && (
              <div className="more-unselec-div">
                <div className="unselec-div">
                  {selectData.filter((el) => el.active).length} <span></span>
                </div>
                <div className="icon-select-clear" onClick={handleUnselectAll}>
                  <IconClientExit />
                </div>
              </div>
            )}
          </div>
        </div>
        <button
          className={`dropdown_button ${open ? "opened" : ""}`}
          type="text"
        >
          <div className={`${open ? "button_active" : ""} button_dropdown`}>
            <DropDown />
          </div>
        </button>
      </div>
      <SlideDown>
        <div
          className={
            open ? "select_option_container " : "select_option_container close"
          }
        >
          {selectData.map((el, i) => (
            <div
              className={
                "select_option trench-chenges" + (el.active ? " active" : "")
              }
              key={i}
            >
              <div className="trench-items-box">
                <div className="input-checkbox-trench">
                  <input
                    onChange={() => handleSelect(el.number, name)}
                    type="checkbox"
                    checked={el.active ?? false}
                    className="form-check-input checkBox "
                  />
                </div>
                <div className="input-trench-text">
                  <span className="trench-info">{el.number}</span>
                </div>
              </div>
              <hr />
              <div>
                {" "}
                Дата погашения: <span>{el.next_payment_date}</span>
              </div>
              <div>
              Остаток долга:{" "}
                <span>
                  {el.remainder} {el.credit_currency}
                </span>
              </div>
              <div>
              Сумма кредита:{" "}
                <span>
                  {el.amount} {el.credit_currency}
                </span>
              </div>
              <div>
                Товар: <span>{el.goods}</span>
              </div>
            </div>
          ))}
        </div>
      </SlideDown>
    </div>
  );
};

export default SelectUserTrench;
